import { Controller } from "@hotwired/stimulus"

// Two-way binds an HTML5 <input type="color"> swatch with a hex text input
// (and back) so editing either field updates the other.
export default class extends Controller {
  static targets = ["swatch", "hex"]

  syncFromSwatch() {
    if (!this.hasHexTarget) return
    this.hexTarget.value = this.swatchTarget.value.toUpperCase()
  }

  syncFromHex() {
    if (!this.hasSwatchTarget) return
    const v = (this.hexTarget.value || "").trim().replace(/^#/, "")
    if (/^[0-9A-Fa-f]{6}$/.test(v)) this.swatchTarget.value = `#${v}`
  }
}
